<!-- <div class="login-wrapper">
    <app-loader *ngIf="isLoading"></app-loader>
    <div class="login-container">
      <div class="header">
        <div class="left">Forgot Password</div>
        <div class="right">
          <img src="assets/MoveinSync-Rentlz.png" class="mr-20 logo" />
        </div>
      </div>
      <ng-container *ngIf="!clientValidated">
        <div>{{clientValidationError}}</div>
      </ng-container>
      <ng-container *ngIf="emailSent">
        <div class="email-sent-msg">If that email address is in our database, we will send you an email to reset your password</div>
      </ng-container>
      <ng-container *ngIf="clientValidated && !emailSent">
        <div class="content">
          <form [formGroup]="formDetails" class="login-form">
            <div class="form-control mb-20">
              <div class="form-label mb-10">Email</div>
              <app-text-input type="email" [formControl]="formDetails.get('email')" class="form-input"></app-text-input>
            </div>
            <div class="error-msg mb-10 text-center font-size-14" *ngIf="showError"> {{errorMessage}}</div>
          </form>
        </div>
        <div class="footer">
          
          <app-button type="primaryFilled" text="Submit" class="mr-20" (clickCallback)="onSubmit()"></app-button>
        </div>
      </ng-container>
    </div>
  </div> -->

<div class="container">
  <div class="forgot-wrapper">

    <div class="logo">
      <svg width="100%" height="100%" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" fit=""
        preserveAspectRatio="xMidYMid meet" focusable="false">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M8.9421 3.81689H37.8197C39.2775 3.81689 40.2106 4.99967 39.9038 6.4554L34.2396 33.4541C33.9328 34.9119 32.5046 36.0926 31.0467 36.0926H2.16915C0.713421 36.0926 -0.219684 34.9119 0.0850037 33.4541L5.74923 6.4554C6.05603 4.99756 7.48425 3.81689 8.9421 3.81689ZM28.0311 13.4399L27.5275 15.577L34.1058 11.2754L29.5545 6.94415L29.0509 9.08543H14.7179C13.0929 9.08543 11.4489 10.4163 11.0659 12.0434L9.41341 19.0682C9.03255 20.6953 10.0186 22.1531 11.6457 22.1531H21.6538L22.1743 19.942L26.7235 24.3431L20.1325 28.6277L20.6382 26.4759H11.9398L12.4412 24.3494L5.87988 28.6722L10.4142 32.9695L10.9157 30.8367H25.3503C26.9753 30.8367 28.6193 29.5058 29.0023 27.8787L30.6844 20.7291C31.0674 19.102 30.0496 17.7711 28.4225 17.7711H18.3107L17.7965 19.9568L13.2305 15.6235L19.8363 11.2817L19.3284 13.4399H28.0311Z"
          fill="#3DAE2B"></path>
      </svg>
    </div>


    <div class="password-container">
      <app-loader *ngIf="isLoading"></app-loader>

      <div style="margin-top: 15px; text-align: center;">
        <h2>Forgot Password</h2>
      </div>
      <ng-container *ngIf="emailSent">
        <div class="email-sent-msg">If that email address is in our database, we will send you an email to reset your
          password</div>
      </ng-container>
      <div class="form-container">
        <form [formGroup]="formDetails" class="form-content">

          <div>
            <mat-form-field appearance="fill" class="form-field-container">

              <mat-label>Email</mat-label>
              <input matInput #email type="email" [formControl]="formDetails.get('email')" class="form-input">
            </mat-form-field>
          </div>

        </form>
        <!-- <app-button type="primaryFilled" text="Submit" (clickCallback)="onSubmit()"></app-button> -->
        <div>
          <app-button type="login" text="Submit" (clickCallback)="onSubmit()" [ngClass]="{'disabled':formDetails.get('email').value === '' }"></app-button>
        </div>


        <!-- <div style="margin-top: 20px;">
              <button mat-button [ngClass]="disable === true? 'disable-submit':'submit-button'">Submit</button>
            </div> -->
        <div class="error-msg mb-10 text-center font-size-14" style="margin:auto; margin: 10px 0px;" *ngIf="showError">
          {{errorMessage}}</div>


        <div style="text-align: center;font-size: 15px; cursor: pointer;">
          <a routerLink="/preprod/login" class="Router">Back</a>
        </div>
      </div>

    </div>
  </div>
</div>